import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IDateProps } from './IDateProps'
import clsx from 'clsx'
import { useDateValidationSchema } from './DateValidationSchema'

interface IDateFieldProps extends HTMLAttributes<HTMLInputElement>, IDateProps { }

export const SimpleDate: FC<IDateFieldProps> = (props) => {
    const { id, placeholder, value: initValue, className, title, readOnly, disabled } = props
    const schema = useDateValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='date'
            id={id}
            className={clsx(className, "form-control form-control-sm")}
            title={title}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
